import classNames from "classnames";
import React from "react";
import { MediaObjectProps } from "./types";

const MediaObject = <C extends React.ElementType = "div">({
  alignment = "start",
  children,
  className,
  element,
  figure,
  reversed = false,
  verticalOnMobile = false,
  ...rest
}: MediaObjectProps<C>): React.ReactElement => {
  const Element = element || "div";
  const mediaObjectClasses = classNames(
    "rds-MediaObject",
    {
      [`rds-MediaObject--${alignment}Alignment`]: alignment !== "start",
      "rds-MediaObject--verticalOnMobile": verticalOnMobile,
      "rds-MediaObject--reversed": reversed,
    },
    className
  );

  return (
    <Element className={mediaObjectClasses} {...rest}>
      <div className="rds-MediaObject-figure">{figure}</div>
      <div className="rds-MediaObject-body">{children}</div>
    </Element>
  );
};

MediaObject.displayName = "MediaObject";

export default MediaObject;
